module.exports = __webpack_public_path__ + "static/media/sn_ab_ldbrd.fb02efe9.jpg";